import { render, staticRenderFns } from "./StepLabel.vue?vue&type=template&id=629ac0b6&scoped=true&lang=pug&"
import script from "./StepLabel.vue?vue&type=script&lang=ts&"
export * from "./StepLabel.vue?vue&type=script&lang=ts&"
import style0 from "./StepLabel.vue?vue&type=style&index=0&id=629ac0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ac0b6",
  null
  
)

export default component.exports